import styled from 'styled-components';

import { BACKGROUND_ERROR, COLOR_ERROR } from '../../../globals';


export const StyledErrorScreen = styled.div`
  display: inherit;
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: ${BACKGROUND_ERROR};
  color: ${COLOR_ERROR};
  font-size: ${props => props.textSize}em;

  .error-container {
    height: 100%;
    width: 100%;
    display: table;
    position: relative;
    left: 0;
    top: 0;
  }

  .error-content {
    border-radius: 1px;
    padding-top: 0;
    padding-left: 10%;
    padding-right: 10%;
    position: static;
    vertical-align: middle;
    display: table-cell;
  }

  .error-title {
    margin: 5px;
    text-align: center;
  }

  .error-icon {
    font-size: ${props => props.textSize + 0.5}em;
    margin: 5px;
    text-align: center;
  }
`;
